@if (link) {
  <a
    class="tp-bento-box hoverable integration-card"
    [style.max-width]="maxWidth"
    [ngClass]="{'integration-card-active': chip == 'active', 'integration-card-coming-soon' : chip == 'coming-soon', 'disabled': !enabled}"
    [attr.href]="link" target="_blank" (click)="onLinkClick()"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else if (clickable) {
  <button
    class="tp-bento-box hoverable integration-card"
    [style.max-width]="maxWidth"
    [ngClass]="{'integration-card-active': chip == 'active', 'integration-card-coming-soon' : chip == 'coming-soon', 'disabled': !enabled}"
    (click)="onLinkClick()"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
} @else {
  <div
    class="tp-bento-box integration-card"
    [style.max-width]="maxWidth"
    [ngClass]="{'integration-card-active': chip == 'active', 'integration-card-coming-soon' : chip == 'coming-soon', 'disabled': !enabled}"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

<ng-template #content>
  @if (imageIcon) {
    <img [src]="imageIcon.src" [alt]="imageIcon.alt" />
  } @else if (faIcon) {
    <i [class]="faIcon" [style.color]="faIconColor ?? 'inherit'"></i>
  }
  <div class="integration-info">
    <h4>{{ title }}</h4>
    <ng-content/>
    <p class="integration-link" [style.visibility]="enabled ? 'visible' : 'hidden'">
      @if (buttonLinkText) {{{ buttonLinkText }}}
    </p>
  </div>
</ng-template>
